import $ from "jquery";
import "slick-carousel";
import jss from 'jss'
import preset from 'jss-preset-default'
import {generateVectorPosition} from '../../../../client/utils/vector-position'

class WidgetEcfCarousel extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        slider: ".ecf-carousel-list",
        slider_item: ".ecf-carousel-item",
        img: ".background-img-position .img-position-item",
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $slider: this.$element.find(selectors.slider),
      $slider_item: this.$element.find(selectors.slider_item),
      $img: this.$element.find(selectors.img),
    };
  }
  getWidth(element,width){
    if(element){
      jss.setup(preset())
      const styles = {
        width_process:{
            width:`${width}% !important`,
          }
        }
        
      const {classes} = jss.createStyleSheet(styles).attach()
      element.classList.add(classes.width_process)
    }
  }

  setHeight(element,height){
    if(element){
      jss.setup(preset())
      const styles = {
        width_process:{
            width:`${width}% !important`,
          }
        }
        
      const {classes} = jss.createStyleSheet(styles).attach()
      element.classList.add(classes.width_process)
    }
  }

  changeStatusProcess(number,slick){
    let onProgress = number + 3;
    let loadProgress = (onProgress / slick.slideCount) * 100;
    return loadProgress;
  }
  startSlick(slider,lengthSliderItem,THIS,processBar){
    slider.on(
      "init",
      function (event, slick, currentSlide, nextSlide) {
        THIS.getWidth(processBar,THIS.changeStatusProcess(0,slick));
      }
    );
  }
  beforeChangeSlick(slider,lengthSliderItem,THIS,processBar){
    slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
          let slick_list = $(".slick-list");
          let onProgress = nextSlide+3;
          THIS.getWidth(processBar,THIS.changeStatusProcess(nextSlide,slick));      
      }
    );
  }
  bindEvents() {
    const THIS = this;
    let slider = $(this.elements.$slider);
    let slider_item = $(this.elements.$slider_item);
    let img_abs = this.elements.$img;
    let idProcess = `Process${slider.attr('id')}`;
    let maxHeight = 0;
    let widthDevice = window.outerWidth;
    let carouselOnLyMb = document.querySelector('#CarouselWeDo.ecf-carousel-list');
    let processBarContainer = document.querySelector(
      `#${idProcess}.ecf-process-bar`
    );
    let itemScrollIpad;
    let processBar = document.querySelector(`#${idProcess}.ecf-process-bar .process`);
    let lengthSliderItem = slider_item.length;
    let desktopItem,desktopTabletItem,tabletItem,mbItem;
    img_abs =  Array.prototype.slice.call(img_abs);

    // get number slide on desktop
    typeof (slider.attr('show-desktop')) == 'undefined' || slider.attr('show-desktop') =='' ? desktopItem=3 : desktopItem=Number(slider.attr('show-desktop'))
      // get number slide on IpadPro
    typeof (slider.attr('show-tablet-desktop')) == 'undefined' || slider.attr('show-tablet-desktop') =='' ? desktopTabletItem=3 : desktopTabletItem=Number(slider.attr('show-tablet-desktop'))
      // get number slider on tablet
    typeof (slider.attr('show-tablet')) == 'undefined' || slider.attr('show-tablet') =='' ? tabletItem=2 : tabletItem=Number(slider.attr('show-tablet'))
      // get number slider on Mobie
    typeof (slider.attr('show-mb')) == 'undefined' || slider.attr('show-mb') =='' ? mbItem=1 : mbItem=Number(slider.attr('show-mb'))

    if(img_abs.length!=0) {
        img_abs.forEach(item => {
          let dataPosition = item.getAttribute('data-position');
          let dataResponsive = item.getAttribute('data-responsive');
          let defaultObj = JSON.parse(atob(dataPosition))
          let responsive = JSON.parse(atob(dataResponsive))
          generateVectorPosition(defaultObj, responsive, item);
      });
    }
    if(processBar){
      lengthSliderItem <4 && processBarContainer.classList.contains('d-lg-block') ? processBarContainer.classList.remove('d-lg-block') : '';
    }
    if (lengthSliderItem!=0) {
      if(widthDevice >= 1023){
        THIS.startSlick(slider,lengthSliderItem,THIS,processBar)
      }
      if(widthDevice >= 1023){
        THIS.beforeChangeSlick(slider,lengthSliderItem,THIS,processBar);
      }
      // $( window ).resize(function() {
      //   let widthResize = window.innerWidth;
      //   if(widthResize >= 1023){
      //     THIS.beforeChangeSlick(slider,lengthSliderItem,THIS,processBar);
      //   }
      // });
      carouselOnLyMb ? itemScrollIpad = 1 : itemScrollIpad = 2;
      lengthSliderItem>1 && slider.slick({
        slidesToShow: desktopItem,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        // centerMode: true,
        focusOnSelect: true,
        // centerPadding: "16px",
        variableWidth: true,
        nextArrow:
          '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
        prevArrow:
          '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: desktopTabletItem,
              slidesToScroll: 1,
              variableWidth: false,
            },
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: tabletItem,
              slidesToScroll: itemScrollIpad,
              variableWidth: false,
              arrows:false
            },
          },
          {
            breakpoint: 763,
            settings: {
              slidesToShow: mbItem,
              slidesToScroll: 1,
              variableWidth: false,
              centerMode: true,
            centerPadding: "13px",
            arrows:false
            },
          },
          {
            breakpoint: 321,
            settings: {
              slidesToShow: mbItem,
              slidesToScroll: 1,
              variableWidth: false,
              centerMode: true,
              centerPadding: "13px",
              arrows:false
            },
          },
        ],
      });
      if(lengthSliderItem%2 != 0 && (widthDevice < 1024 && widthDevice > 767)){
        if(!document.querySelector('#CarouselWeDo')){
          slider.slick('slickAdd', '<div><div><div class="slick-item"></div></div></div>')
        }
      }
      let slickArrow = $(
        ".slick-arrow"
      );
      let slickList = $('.slick-list');
      slickArrow.hover(()=>{
        slickList.toggleClass('hover');
      })
    }
  }
}

jQuery(window).on("elementor/frontend/init", () => {
  const addHandler = ($element) => {
    elementorFrontend.elementsHandler.addHandler(WidgetEcfCarousel, {
      $element,
    });
  };

  elementorFrontend.hooks.addAction(
    "frontend/element_ready/ecf_see_whats.default",
    addHandler
  );
});
